export default "__VITE_ASSET__YA7dVreq__"